import * as types from '../types';
import {
  FlagsAction,
  SetActionSuccessFlagAction,
  SetCreateAndGoPracticeFlagAction,
  SetDataOpsFetchFlagAction,
  SetFileIsDownloadingAction,
  SetGameReprocessFlagAction,
  SetLiveFetchFlagAction,
  SetPastFetchFlagAction,
  SetPlaysIgnoreSavedFlagAction,
  SetPracticeSavedSuccessfullyFlagAction,
  SetScheduleFetchFlagAction,
} from "../types";

export const changeLiveFetchFlag = (flag: boolean): SetLiveFetchFlagAction => {
  return {
    type: FlagsAction.SET_LIVE_FETCH_FLAG,
    liveFetch: flag
  };
};

export const changePastFetchFlag = (flag: boolean): SetPastFetchFlagAction  => {
  return {
    type: FlagsAction.SET_PAST_FETCH_FLAG,
    pastFetch: flag
  };
};

export const changeScheduleFetchFlag = (flag: boolean): SetScheduleFetchFlagAction => {
  return {
    type: FlagsAction.SET_SCHEDULE_FETCH_FLAG,
    scheduleFetch: flag
  };
};

export const changeDataOpsFetchFlag = (flag: boolean): SetDataOpsFetchFlagAction => {
  return {
    type: FlagsAction.SET_DATAOPS_FETCH_FLAG,
    dataOpsFetch: flag
  };
};

export const changePracticeSavedSuccessfullyFlag = (flag: boolean): SetPracticeSavedSuccessfullyFlagAction => {
  return {
    type: FlagsAction.SET_PRACICE_SAVED_SUCCESSFULLY_FLAG,
    practiceSaved: flag,
  };
};

export const changeActionSuccessFlag = (actionMessage: string | null, actionSucceeded: boolean | null): SetActionSuccessFlagAction => {
  return {
    type: FlagsAction.SET_ACTION_SUCCESSFULLY_STARTED,
    actionMessage,
    actionSucceeded,
  };
};

export const fileIsDownloading = (flag: boolean): SetFileIsDownloadingAction=>{
  return{
    type: FlagsAction.DOWNLOADING_FLAG,
    download: false || flag,
  };
};

export const createAndGoPracticeFlag = (flag: boolean): SetCreateAndGoPracticeFlagAction=>{
  return{
    type: FlagsAction.CREATE_AND_GO_FLAG,
    createAndGoFlag: false || flag,
  };
};

export const playsIgnoreSavedFlag = (flag: boolean): SetPlaysIgnoreSavedFlagAction=>{
  return{
    type: FlagsAction.PLAYS_IGNORE_SAVED_FLAG,
    playsSavedFlag: false || flag,
  };
};

export const gameReprocessFlag = (status: string | boolean): SetGameReprocessFlagAction =>{
  return{
    type: FlagsAction.GAME_REPROCESS_FLAG,
    reprocessFlag: false || status,
  };
};